import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';

import * as Api from './api';
import * as Actions from './actions';

/*
    CRUD epics
 */
export const fetchObservable = institutionId =>
    Api.fetch(institutionId).map(({statuses, behaviors}) => ({
        statusSuccessAction: Actions.fetchSuccess.action(statuses),
        behaviors,
    }));

const fetch = action$ =>
    action$.ofType(Actions.fetch.type).mergeMap(({payload}) =>
        fetchObservable(payload.institutionId)
            .map(({statusSuccessAction}) => statusSuccessAction)
            .catch(e => Observable.of(Actions.fetchFailed.action(e))),
    );

export const createObservable = (institutionId, icon, color, title) =>
    Api.create(institutionId, icon, color, title).map(status => Actions.createSuccess.action(status));

const create = action$ =>
    action$
        .ofType(Actions.create.type)
        .mergeMap(({payload}) =>
            createObservable(payload.institutionId, payload.icon, payload.color, payload.title).catch(e =>
                Observable.of(Actions.createFailed.action(e)),
            ),
        );

export const updateObservable = (statusConfigId, icon, color, title) =>
    Api.update(statusConfigId, icon, color, title).map(status => Actions.updateSuccess.action(status));

const update = action$ =>
    action$
        .ofType(Actions.update.type)
        .mergeMap(({payload}) =>
            updateObservable(payload.statusConfigId, payload.icon, payload.color, payload.title).catch(e =>
                Observable.of(Actions.updateFailed.action(e)),
            ),
        );

const remove = action$ =>
    action$.ofType(Actions.remove.type).mergeMap(({payload}) =>
        Api.remove(payload.statusConfigId)
            .map(() => Actions.removeSuccess.action(payload.statusConfigId))
            .catch(e => Observable.of(Actions.removeFailed.action(e))),
    );

/*
    Epics concerning starting and ending statuses on people
 */
const applyStatus = action$ =>
    action$.ofType(Actions.applyStatus.type).mergeMap(({payload}) =>
        Api.applyStatus(payload.statusConfigId, payload.childIds, payload.employeeIds)
            .map(() => Actions.applyStatusSuccess.action(payload.statusConfigId, payload.childIds, payload.employeeIds))
            .catch(e => Observable.of(Actions.applyStatusFailed.action(e))),
    );
const endStatus = action$ =>
    action$.ofType(Actions.endStatus.type).mergeMap(({payload}) =>
        Api.endStatus(payload.statusConfigId, payload.childIds, payload.employeeIds)
            .map(() => Actions.endStatusSuccess.action(payload.statusConfigId, payload.childIds, payload.employeeIds))
            .catch(() => Observable.of(Actions.endStatusFailed.action(payload.statusConfigId))),
    );

export default combineEpics(fetch, create, update, remove, applyStatus, endStatus);
